import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { installChunkReloadHandlers } from './utils/chunkReload';

// Auto-reload once if a lazy-loaded chunk 404s after a mid-session deploy.
installChunkReloadHandlers();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
